/**
 * Multilanguage profiles module
 *
 * @author MattJS (matt@yext.com)
 */
goog.module('yext.location.ml');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const dialog = goog.require('yext.dialog');
const notify = goog.require('yext.notify');
/** @suppress {extraRequire} */
goog.require('yext.plugins.contextualHelp');


var $context = $('.js-languages-sidebar');
var $alternateLanguages = $context.find('.js-alternate-languages');
var $addLanguageDialog = $('.js-add-language-dialog');
var $removeLanguageDialog = $('.js-remove-language-dialog');
var $setAsPrimaryDialog = $('.js-set-as-primary-dialog');
var $changeLanguageDialog = $('.js-change-language-dialog');
var $addLocaleSelect = $addLanguageDialog.find('.js-locale-select-gumi');
var $addLocaleSelectNote = $addLanguageDialog.find('.js-add-language-note');
var $changeLocaleSelect = $changeLanguageDialog.find('.js-locale-select-gumi');
var $optionsTemplate = $($('.js-language-options-template').html());
var $altLanguageTemplate = $($('.js-alt-language-template').html());

var profiles = []; // List of languages for this location
var locales = {}; // Map from locale code to display name
var primaryUrl = $context.data('primary-url'); // Url of primary profile for redirection
var baseUrl = $context.data('base-url'); // url used to differentiate between entity edit and location edit page
var currentLocale = $('[data-current]').data('localeCode');
var numLocations = $('[name="js-num-locations"]').val();
var templateId = $('input[name="templateId"]').val();

/**
 * Initialize this module
 */
function init() {
  getLocalesAndBindLanguages();
  bindOptionsClose();
  bindAddLanguage();
  bindRemoveLanguage();
  bindChangeLanguage();
  bindSetAsPrimary();
  bindFieldRowTooltips();
}

function getProfiles() {
  return profiles;
}

/**
 * Retrieve all possible locales from dom and bind the options
 * dropdowns for primary and alternate languages.
 *
 * All possible locales is the union of the locales avaliable from the
 * dropdown and any alternate language locales currently on the location
 */
var getLocalesAndBindLanguages = function() {
  // Get locales from dropdown
  $addLocaleSelect.find('ul li').each(function() {
    var $this = $(this);
    locales[$this.data('value')] = $this.text();
  });
  // Bind languages dropdown
  $context.find('.js-language-wrap').each(function() {
    var language = new Language($(this));
    profiles.push(language);
    locales[language.localeCode] = language.$element.find('.js-language-name').text();
  });
};

/**
 * Hide the options when there is a clickout event
 */
var bindOptionsClose = function() {
  $('body').on('click', function(e) {
    var $target = $(e.target);
    if (!$target.closest('.js-language-options').length
        && !$target.hasClass('js-show-language-options')) {
      closeAllLanguageOptions();
    }
  });
};

/**
 * Closes all the language option dropdowns
 */
var closeAllLanguageOptions = function() {
  profiles.forEach(function(language) {
    language.hideOptions();
  });
};

/**
 * Bind the add language dialog
 * @suppress {deprecated}
 * @suppress {deprecated}
 */
var bindAddLanguage = function() {
  var $addButton = $addLanguageDialog.find('.js-add-language-button');
  var locationSearchParam = encodeURIComponent(window.location.search.substring(1));

  $addLanguageDialog.dialog({
    autoOpen: false,
    modal: true,
    draggable: false,
    resizable: false,
    width: 400,
    title: yext.msg('Add an Alternate Language'),
    close: function() {
      $addLocaleSelect.data('gumi').reset();
      resetButtonLabel($addLocaleSelect.find('button'));
      $addButton.prop('disabled', true);
      $addLocaleSelectNote.text('');
    },
  });

  $context.find('.js-show-add-language').click(function() {
    $addLanguageDialog.dialog('open');
  });

  $addLocaleSelect.gumi('onEvent', 'onChange', function() {
    var localeCode = $addLocaleSelect.data('gumi').val();
    var count = getProfileCountForLocale(localeCode);
    $addButton.prop('disabled', false);
    if (count > 0 && count != numLocations) {
      if (isEntityEditPage()) {
        $addLocaleSelectNote.text(yext.msg('Note: This language will be added only to entities that don\'t already have a {0} profile.', locales[localeCode]));
      } else {
        $addLocaleSelectNote.text(yext.msg('Note: This language will be added only to locations that don\'t already have a {0} profile.', locales[localeCode]));
      }
    } else {
      $addLocaleSelectNote.text('');
    }
  });

  $addLanguageDialog.find('.js-cancel').click(function() {
    $addLanguageDialog.dialog('close');
  });

  // Create a new alternate language profile
  $addButton.click(function() {
    var localeCode = $addLocaleSelect.data('gumi').val();
    var count = getProfileCountForLocale(localeCode);
    var reqData = addSearchParam({
      localeCode: localeCode,
      templateId: templateId,
    },
    locationSearchParam);

    $addButton.prop('disabled', true);
    $.ajax({
      url: baseUrl + 'add',
      data: reqData,
      type: 'POST',
      success: function(response) {
        addAlternateLanguage(localeCode, count);
        $addLanguageDialog.dialog('close');
        if (response.error) {
          notify.showError(response.error, 15000);
        } else if (templateId) {
          notify.showSuccess(
            // TRANSLATORS {0} is the name of a language (e.g. French, German or Japanese)
            yext.msg('Success! {0} language was added to this template', locales[localeCode]));
        } else {
          if (isEntityEditPage()) {
            notify.showSuccess(
              // TRANSLATORS {0} is the name of a language (e.g. French, German or Japanese)
              yext.msg('Success! {0} language was added to this entity', locales[localeCode]));
          } else {
            notify.showSuccess(
              // TRANSLATORS {0} is the name of a language (e.g. French, German or Japanese)
              yext.msg('Success! {0} language was added to this location', locales[localeCode]));
          }
        }
      },
      error: function() {
        notify.showError(yext.msg('There was an error while adding an alternate language'));
      },
    });
  });
};

/**
 * Looks through the Language objects to get the locale counts
 *
 * @param {string} localeCode The locale code to look for
 * @return {number} The number of profiles with this locale for the locations being edited
 */
var getProfileCountForLocale = function(localeCode) {
  var profile = getProfileForLocale(localeCode);
  return profile ? profile.count : 0;
};

/**
 * Looks through the Language objects to get the one matching the given locale
 *
 * @param {string} localeCode The locale code to look for
 * @return {Language} language The Language object with this locale
 */
var getProfileForLocale = function(localeCode) {
  for (var i = 0; i < profiles.length; i++) {
    if (profiles[i].localeCode === localeCode) {
      return profiles[i];
    }
  }
  return null;
};

/**
 * Examine alternate language dropdown and return true if all options disabled
 */
var languagesAvailableToAdd = function() {
  var result = false;
  $addLocaleSelect.find('ul li').each(function() {
    // end function call as soon as an enabled language is seen
    if (!$(this).data('disabled')) {
      result = true;
      return false;
    }
  });
  return result;
};

/**
 * Add element to the list of alternate languages
 * @param {string} localeCode Code for locale being added
 * @param {int} count Number of existing profiles with given locale
 */
var addAlternateLanguage = function(localeCode, count) {
  if (count == 0) {
    var $item = $altLanguageTemplate.clone();
    $item.find('.js-language-name').text(locales[localeCode]);
    $item.find('.js-language-count').text(numLocations);
    $item.data({
      localeCode: localeCode,
      count: numLocations,
      altLocationsCount: numLocations,
    });
    $item.attr('data-local-code', localeCode);
    var language = new Language($item);
    language.count = numLocations;
    language.setLink();
    profiles.push(language);
    $alternateLanguages.append($item);
    $alternateLanguages.show();
  } else {
    var profile = getProfileForLocale(localeCode);
    var altLocationCount = numLocations - (profile.count - profile.altLocationsCount);
    profile.setAltLocationCount(altLocationCount);
    profile.setCount(numLocations);
    profile.resetOptionStatus();
  }
  changeLocaleSelectStatus(localeCode, true, numLocations);
  if (!languagesAvailableToAdd()) {
    $context.find('.js-add-alternate-wrap').hide();
  }
};

/**
 * Bind the set as primary dialog
 * @suppress {deprecated}
 */
var bindSetAsPrimary = function() {
  $setAsPrimaryDialog.dialog({
    autoOpen: false,
    modal: true,
    draggable: false,
    resizable: false,
    width: 400,
    title: yext.msg('Set A New Primary Language'),
    close: function() {
      $('.js-set-as-primary-message').text('');
      $setAsPrimaryDialog.find('.js-set-as-primary-button').off('click');
    },
  });

  $setAsPrimaryDialog.find('.js-cancel').click(function() {
    $setAsPrimaryDialog.dialog('close');
  });
};

/**
 * Show the dialog for setting a new primary language
 * @param {Language} language the Language instance being set as primary
 * @suppress {deprecated}
 */
var showSetAsPrimaryDialog = function(language) {
  var languageName = locales[language.localeCode];
  var $setAsPrimaryMsg = $setAsPrimaryDialog.find('.js-set-as-primary-message');
  if (templateId) {
    $setAsPrimaryMsg.text(yext.msg(
      'You are about to set {0} as this template\'s Primary Language.', languageName));
  } else {
    if (isEntityEditPage()) {
      $setAsPrimaryMsg.text(yext.msgn(
        'You are about to set {1} as this entity\'s Primary Language.',
        'You are about to set {1} as the Primary Language for all selected entities.',
        numLocations, languageName));
    } else {
      $setAsPrimaryMsg.text(yext.msgn(
        'You are about to set {1} as this location\'s Primary Language.',
        'You are about to set {1} as the Primary Language for all selected locations.',
        numLocations, languageName));
    }
  }
  $setAsPrimaryDialog.dialog('open');
  $setAsPrimaryDialog.find('.js-set-as-primary-button')
    .click(function() {
      setAsPrimaryHandler(language);
    })
    .find('span').text(yext.msg('Set {0} as Primary', languageName));
};

/**
 * Bind the click handler to the set new primary language button in the set a new primary language dialog
 * @param {Language} language Language instance to be set as primary
 * @suppress {deprecated}
 * @suppress {deprecated}
 */
var setAsPrimaryHandler = function(language) {
  var locationSearchParam = encodeURIComponent(window.location.search.substring(1));
  var localeCode = language.localeCode;
  $setAsPrimaryDialog.dialog('close');
  // TODO(slanden): use ProgressJob/similar to show actual progress of operation
  var dialogMsg;
  if (templateId) {
    dialogMsg = yext.msg(
      'Setting {0} as the Primary language for this template...', locales[localeCode]);
  } else if (numLocations == 1) {
    if (isEntityEditPage()) {
      dialogMsg = yext.msg(
        'Setting {0} as the Primary Language for this entity...', locales[localeCode]);
    } else {
      dialogMsg = yext.msg(
        'Setting {0} as the Primary Language for this location...', locales[localeCode]);
    }
  } else {
    if (isEntityEditPage()) {
      dialogMsg = yext.msgn(
        'Setting {1} as the Primary Language for 1 entity...',
        'Setting {1} as the Primary Language for {0} entities...',
        language.altLocationsCount, locales[localeCode]);
    } else {
      dialogMsg = yext.msgn(
        'Setting {1} as the Primary Language for 1 location...',
        'Setting {1} as the Primary Language for {0} locations...',
        language.altLocationsCount, locales[localeCode]);
    }
  }
  var dialogTimeout = dialog.showDelayedProgressDialog(dialogMsg);
  var reqData = addSearchParam({
    localeCode: localeCode,
    templateId: templateId,
  },
  locationSearchParam);

  $.ajax({
    url: baseUrl + 'setPrimary',
    data: reqData,
    type: 'POST',
    success: function(response) {
      dialog.hideDelayedProgressDialog(dialogTimeout);

      if (response.error) {
        notify.showError(response.error, 15000);
      } else {
        if (numLocations == 1) {
          notify.showSuccess(yext.msg(
            'Success! Primary language set as {0}',
            locales[localeCode]));
        } else {
          if (isEntityEditPage()) {
            notify.showSuccess(yext.msgn(
              'Success! Primary language set as {1} for 1 entity.',
              'Success! Primary language profile set to {1} for {0} entities.',
              language.altLocationsCount, locales[localeCode]));
          } else {
            notify.showSuccess(yext.msgn(
              'Success! Primary language set as {1} for 1 location.',
              'Success! Primary language profile set to {1} for {0} locations.',
              language.altLocationsCount, locales[localeCode]));
          }
        }
        setTimeout(function() {
          window.location.href = primaryUrl;
        }, 1000);
      }
    },
    error: function() {
      dialog.hideDelayedProgressDialog(dialogTimeout);
      notify.showError(yext.msg(
        '{0} could not be set as a primary language. Your data is safe - no changes have been made.',
        locales[localeCode]));
    },
  });
};

/**
 * Bind the remove language dialog
 * @suppress {deprecated}
 */
var bindRemoveLanguage = function() {
  $removeLanguageDialog.dialog({
    autoOpen: false,
    modal: true,
    draggable: false,
    resizable: false,
    width: 400,
    title: yext.msg('Remove Alternate Language'),
    close: function() {
      $('.js-remove-language-message').text('');
      $removeLanguageDialog.find('.js-remove-language-button').off('click');
    },
  });

  $removeLanguageDialog.find('.js-cancel').click(function() {
    $removeLanguageDialog.dialog('close');
  });
};

/**
 * Remove element from the list of alternate languages
 * @param {Language} language Language instance to be removed
 */
var removeAlternateLanguage = function(language) {
  if (language.altLocationsCount == language.count) {
    if (language.isCurrent) {
      window.location = language.$element.find('.js-language').data('href');
      return;
    }
    language.$element.remove();
    var index = profiles.indexOf(language);
    profiles.splice(index, 1);
    changeLocaleSelectStatus(language.localeCode, false, 0);
    if (profiles.length == 1) {
      $alternateLanguages.hide();
    }
  } else {
    language.count -= language.altLocationsCount;
    language.altLocationsCount = 0;
    changeLocaleSelectStatus(language.localeCode, false, language.count);
    language.$element.find('.js-language-count').text(language.count);
    language.resetOptionStatus();
  }
  $context.find('.js-add-alternate-wrap').show();
};

/**
 * Show the dialog for removing a language
 * @param {Language} language Language instance being removed
 * @suppress {deprecated}
 */
var showRemoveLanguageDialog = function(language) {
  var localeCode = language.localeCode;
  if (templateId) {
    $removeLanguageDialog.find('.js-remove-language-message').text(
      yext.msg('You are about to remove {0} content from this template. Once removed, this content cannot be recovered.', locales[localeCode]));
  } else if (numLocations == 1) {
    if (isEntityEditPage()) {
      $removeLanguageDialog.find('.js-remove-language-message').text(
        yext.msg('You are about to remove {0} content from this entity. Once removed, this content cannot be recovered.', locales[localeCode]));
    } else {
      $removeLanguageDialog.find('.js-remove-language-message').text(
        yext.msg('You are about to remove {0} content from this location. Once removed, this content cannot be recovered.', locales[localeCode]));
    }
  } else {
    if (isEntityEditPage()) {
      $removeLanguageDialog.find('.js-remove-language-message').text(yext.msgn(
        'You are about to remove {1} from 1 entity.',
        'You are about to remove {1} from {0} entities.',
        language.altLocationsCount, locales[localeCode]));
    } else {
      $removeLanguageDialog.find('.js-remove-language-message').text(yext.msgn(
        'You are about to remove {1} from 1 location.',
        'You are about to remove {1} from {0} locations.',
        language.altLocationsCount, locales[localeCode]));
    }
  }
  $removeLanguageDialog.dialog('open');
  $removeLanguageDialog.find('.js-remove-language-button').click(function() {
    removeLanguageHandler(language);
  });
};

/**
 * Bind the click handler to the remove button in the remove alternate language dialog
 * @param {Language} language Language instance to be removed
 * @suppress {deprecated}
 * @suppress {deprecated}
 */
var removeLanguageHandler = function(language) {
  var locationSearchParam = encodeURIComponent(window.location.search.substring(1));
  var localeCode = language.localeCode;
  var reqData = addSearchParam({
    localeCode: localeCode,
    templateId: templateId,
  },
  locationSearchParam);

  $.ajax({
    url: baseUrl + 'remove',
    data: reqData,
    type: 'POST',
    success: function(response) {
      if (response.error) {
        notify.showError(response.error, 15000);
      } else if (templateId) {
        notify.showSuccess(yext.msg('Success! {0} was removed from this template', locales[localeCode]));
      } else if (numLocations == 1) {
        if (isEntityEditPage()) {
          notify.showSuccess(yext.msg('Success! {0} was removed from this entity', locales[localeCode]));
        } else {
          notify.showSuccess(yext.msg('Success! {0} was removed from this location', locales[localeCode]));
        }
      } else {
        if (isEntityEditPage()) {
          notify.showSuccess(yext.msgn(
            'Success! {1} language was removed from 1 entity.',
            'Success! {1} language was removed from {0} entities.',
            language.altLocationsCount, locales[localeCode]));
        } else {
          notify.showSuccess(yext.msgn(
            'Success! {1} language was removed from 1 location.',
            'Success! {1} language was removed from {0} locations.',
            language.altLocationsCount, locales[localeCode]));
        }
      }
      removeAlternateLanguage(language);
      $removeLanguageDialog.dialog('close');
    },
    error: function() {
      notify.showError(yext.msg('There was an error while removing an alternate language'));
    },
  });
};

/**
 * Changes the disabled status of an element in the locale select.
 * @param {string} localeCode Code for locale being added
 * @param {integer} count Number of locations that have the locale
 * @param {boolean} disabled New disabled status
 */
var changeLocaleSelectStatus = function(localeCode, disabled, count) {
  $addLocaleSelect.find('li[data-value="' + localeCode + '"]').data({
    disabled: disabled,
    count: count,
  });
  $changeLocaleSelect.find('li[data-value="' + localeCode + '"]').data('disabled', disabled);
  $addLocaleSelect.data('gumi')._updateSelect();
  $changeLocaleSelect.data('gumi')._updateSelect();
  resetButtonLabel($addLocaleSelect.find('button'));
  resetButtonLabel($changeLocaleSelect.find('button'));
};

/**
 * Put the button label back to its display value
 * @param {!jQuery} $button The button to be reset
 */
var resetButtonLabel = function($button) {
  var label = $button.data('buttonLabel');
  $button.find('em').html(label);
};

/**
 * Bind the change language dialog
 * @suppress {deprecated}
 */
var bindChangeLanguage = function() {
  var $changeButton = $changeLanguageDialog.find('.js-change-language-button');
  var locationSearchParam = encodeURIComponent(window.location.search.substring(1));

  $changeLanguageDialog.dialog({
    autoOpen: false,
    modal: true,
    draggable: false,
    resizable: false,
    width: 400,
    title: yext.msg('Change Language'),
    close: function() {
      $changeLanguageDialog.find('.js-change-language-button').off('click');
      $changeLocaleSelect.data('gumi').reset();
      resetButtonLabel($changeLocaleSelect.find('button'));
      $changeButton.prop('disabled', true);
    },
  });

  $changeLocaleSelect.gumi('onEvent', 'onChange', function() {
    $changeButton.prop('disabled', false);
  });

  $changeLanguageDialog.find('.js-cancel').click(function() {
    $changeLanguageDialog.dialog('close');
  });
};

/**
 * Show the dialog for changing the language for a profile.
 * @param {Language} language Language instance to be changed
 * @suppress {deprecated}
 */
var showChangeLanguageDialog = function(language) {
  $changeLanguageDialog.find('.js-change-language-message').text(
    yext.msg('Select a language to replace {0}', locales[language.localeCode]));
  $changeLanguageDialog.dialog('open');
  $changeLanguageDialog.find('.js-change-language-button').click(function() {
    changeLanguageHandler(language);
  });
};

/**
 * Bind the click handler to the save button in the change language dialog
 * @param {Language} language Language instance to be changed
 * @suppress {deprecated}
 * @suppress {deprecated}
 */
var changeLanguageHandler = function(language) {
  var locationSearchParam = encodeURIComponent(window.location.search.substring(1));
  var targetLocaleCode = $changeLocaleSelect.data('gumi').val();
  var currentLocaleCode = language.localeCode;
  var reqData = addSearchParam({
    currentLocaleCode: currentLocaleCode,
    targetLocaleCode: targetLocaleCode,
    templateId: templateId,
  },
  locationSearchParam);

  $.ajax({
    url: baseUrl + 'change',
    data: reqData,
    type: 'POST',
    success: function(response) {
      if (response.error) {
        notify.showError(response.error, 15000);
      } else {
        changeLanguageProfile(language, targetLocaleCode);
        $changeLanguageDialog.dialog('close');
        notify.showSuccess(
          yext.msg('Success! The profile language was changed from {0} to {1}.',
            locales[currentLocaleCode], locales[targetLocaleCode]));
      }
    },
    error: function() {
      notify.showError(yext.msg('There was an error while changing a language'));
    },
  });
};

/**
 * Change the element in the list of languages
 * @param {Language} language Language instance to be changed
 * @param {string} targetLocaleCode New language value
 */
var changeLanguageProfile = function(language, targetLocaleCode) {
  if (language.isCurrent) {
    window.location = language.$element.find('.js-language').data('href') + 'locale=' + targetLocaleCode;
    return;
  }

  changeLocaleSelectStatus(language.localeCode, false, 0);
  changeLocaleSelectStatus(targetLocaleCode, true, numLocations);
  language.localeCode = targetLocaleCode;
  language.setLink();
  language.$element.data('localeCode', targetLocaleCode)
    .find('.js-language-name').text(locales[targetLocaleCode]);
};

var basicTooltipOptions = {
  event: 'hover',
  location: 'right',
  hoverDelay: 300,
  fadeDuration: 300,
  propagate: true,
};

/**
 * Bind alternate profile tooltips for field rows that describe if a field is
 * overridable, primary only, etc.
 */
var bindFieldRowTooltips = function() {
  $('.js-overridable-field').contextualHelp($.extend({}, basicTooltipOptions, {
    contentElement: '.js-overridable-tooltip',
    condition: function() {
      return !$(this).hasClass('profile-row-edit');
    },
  }));

  $('.js-primary-only-field').contextualHelp($.extend({}, basicTooltipOptions, {
    contentElement: '.js-primary-only-tooltip',
  }));

  $('.js-primary-has-asset').contextualHelp($.extend({}, basicTooltipOptions, {
    contentElement: '.js-primary-has-asset-tooltip',
  }));

  var photosTooltipMsg = yext.msg(
    'Adding photos will create a new photo gallery that will only be shown with your {0} content.',
    locales[currentLocale]);
  $('.js-photos-tooltip p').text(photosTooltipMsg);

  $('.js-photos-field').contextualHelp($.extend({}, basicTooltipOptions, {
    contentElement: '.js-photos-tooltip',
    condition: function() {
      return !$(this).hasClass('profile-row-edit');
    },
  }));
};

/**
 * Bind the click handler to the add to all locations option during bulk edit.
 * @param {Language} language Language instance to be added to remaining locations
 * @suppress {deprecated}
 */
var addToAllLocationsHandler = function(language) {
  var locationSearchParam = encodeURIComponent(window.location.search.substring(1));
  var localeCode = language.localeCode;
  var remainingProfiles = numLocations - language.count;
  var dialogTimeout;

  if (isEntityEditPage()) {
    dialogTimeout = dialog.showDelayedProgressDialog(yext.msgn(
      'Adding {1} language profile to 1 entity...',
      'Adding {1} language profiles to {0} entities...',
      remainingProfiles, locales[localeCode]));
  } else {
    dialogTimeout = dialog.showDelayedProgressDialog(yext.msgn(
      'Adding {1} language profile to 1 location...',
      'Adding {1} language profiles to {0} locations...',
      remainingProfiles, locales[localeCode]));
  }
  closeAllLanguageOptions();

  var reqData = addSearchParam({
    localeCode: localeCode,
  },
  locationSearchParam);

  $.ajax({
    url: baseUrl + 'add',
    data: reqData,
    type: 'POST',
    success: function(response) {
      if (response.error) {
        notify.showError(response.error, 15000);
      } else {
        language.altLocationsCount += (numLocations - language.count);
        language.count = numLocations;
        language.$element.find('.js-language-count').text(language.count);
        language.resetOptionStatus();

        changeLocaleSelectStatus(localeCode, true, numLocations);
        dialog.hideDelayedProgressDialog(dialogTimeout);
        if (isEntityEditPage()) {
          notify.showSuccess(yext.msgn(
            'Success! {1} alternate language was added to 1 entity.',
            'Success! {1} alternate language was added to {0} entities.',
            remainingProfiles, locales[localeCode]));
        } else {
          notify.showSuccess(yext.msgn(
            'Success! {1} alternate language was added to 1 location.',
            'Success! {1} alternate language was added to {0} locations.',
            remainingProfiles, locales[localeCode]));
        }
      }
    },
    error: function() {
      dialog.hideDelayedProgressDialog(dialogTimeout);
      notify.showError(yext.msg('There was an error while adding an alternate language'));
    },
  });
};

/**
 * @param {info} data to be sent in the ajax call
 * @param {locationSearchParam} the parameter to be added to info
 *
 * @return Returns info with correct parameter name added
 */
var addSearchParam = function(info, locationSearchParam) {
  if (isEntityEditPage()) {
    info.entitySearchParam = locationSearchParam;
  } else {
    info.locationSearchParam = locationSearchParam;
  }
  return info;
};

/**
 * @return True if we are on the entity edit page
 */
var isEntityEditPage = function() {
  return baseUrl.indexOf('entity') != -1;
};

/**
 * Language details and options
 *
 * @constructor
 */
var Language = function($element) {
  this.$element = $element;
  this.$showOptions = $element.find('.js-show-language-options');
  this.$options = $optionsTemplate.clone();

  this.isPrimary = !!$element.data('primary');
  this.isCurrent = !!$element.data('current');
  this.localeCode = $element.data('localeCode');
  this.count = $element.data('count');
  this.altLocationsCount = $element.data('alt-locations-count');

  this.bindOptions();
  this.bindShowOptions();
};

/**
 * Add the locale code to the profile link
 */
Language.prototype.setLink = function() {
  var href = this.$element.find('.js-language').attr('href');
  var localeIndex = href.indexOf('locale=');
  if (localeIndex != -1) {
    href = href.substring(0, localeIndex);
  }
  this.$element.find('.js-language')
    .attr('href', href + 'locale=' + this.localeCode);
};

/**
 * Set the location count for a profile
 *
 * @param {int} count Updated number of locations with this locale
 */
Language.prototype.setCount = function(count) {
  this.count = count;
  this.$element.find('.js-language-count').text(count);
};

/**
 * Set the alternate location count for a profile
 *
 * @param {int} count Updated number of locations with an alternate profile
 * in this locale
 */
Language.prototype.setAltLocationCount = function(count) {
  this.altLocationsCount = count;
};

/**
 * Bind show options dropdown
 */
Language.prototype.bindShowOptions = function() {
  var self = this;
  this.$showOptions.click(function() {
    var visible = self.$options.is(':visible');
    closeAllLanguageOptions();
    if (!visible) {
      self.$options.show();
      self.$element.addClass('active');
      self.$options.position({
        my: 'right top',
        at: 'right bottom',
        offset: '0 2',
        of: self.$showOptions,
      });
    }
  });
};

/**
 * Bind options operations
 */
Language.prototype.bindOptions = function() {
  var $setAsPrimary = this.$options.find('.js-set-as-primary');
  var $removeLanguage = this.$options.find('.js-remove-language');
  var self = this;

  $('body').append(this.$options);

  this.$options.find('.js-change-language').click(function() {
    showChangeLanguageDialog(self);
  });

  if (this.isPrimary) {
    $setAsPrimary.closest('li').remove();
    $removeLanguage.closest('li').remove();
  } else {
    $setAsPrimary.click(function() {
      showSetAsPrimaryDialog(self);
    });
    $removeLanguage.click(function() {
      showRemoveLanguageDialog(self);
    });
  }

  if (numLocations > 1) {
    this.$options.find('.js-add-to-all').click(function() {
      addToAllLocationsHandler(self);
    });
    this.resetOptionStatus();
  }
};

/**
 * Disable/enable language options based on current state
 */
Language.prototype.resetOptionStatus = function() {
  var $addToAll = this.$options.find('.js-add-to-all');
  var $setAsPrimary = this.$options.find('.js-set-as-primary');
  var $removeLanguage = this.$options.find('.js-remove-language');
  if (this.count < numLocations) {
    $addToAll.prop('disabled', false);
    $setAsPrimary.prop('disabled', true);
  } else {
    $addToAll.prop('disabled', true);
    $setAsPrimary.prop('disabled', false);
  }
  if (this.altLocationsCount == 0) {
    $removeLanguage.prop('disabled', true);
  } else {
    $removeLanguage.prop('disabled', false);
  }
};

/**
 * Hide the options dropdown
 */
Language.prototype.hideOptions = function() {
  this.$options.hide();
  this.$element.removeClass('active');
};

exports = {
  init,
  getProfiles,
};
